import { render, staticRenderFns } from "./AssociateAutomation.vue?vue&type=template&id=64274444"
import script from "./AssociateAutomation.vue?vue&type=script&lang=js"
export * from "./AssociateAutomation.vue?vue&type=script&lang=js"
import style0 from "./AssociateAutomation.vue?vue&type=style&index=0&id=64274444&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports